var modules_1be33e45 = {"container":"_5teno8","firstColumn":"_1k1g6q3","secondColumn":"_1cmqbha"};
import "../../../assets/D1sNMNFT.css";

export { modules_1be33e45 as default };
//# sourceMappingURL=StoresBanner.module.less.js.map
